<template>
    <v-container class="px-0">
        <v-snackbar v-model="snackbar.mostrar" :color="snackbar.tipo" :timeout="6000">
            {{ snackbar.mensaje }}
            <v-btn text @click="snackbar.mostrar = false">
                {{$t('cerrar') | capitalize}}
            </v-btn>
        </v-snackbar>

        <v-alert v-if="!materiales.cargando && materiales.paginas === 0" type="info" class="ma-12">
            <span class="body-1">{{$t('sin_materiales')}}&nbsp;</span>
            <btn-add-material-pers :disabled="materiales.cargando" @actualizado="actualizadoMaterial"/>
        </v-alert>

        <div v-if="materiales.cargando || materiales.paginas > 0">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-toolbar color="transparent primary--text" flat>
                        <v-toolbar-title class="font-weight-bold">
                            <v-avatar color="primary">
                                <v-icon color="white">mdi-folder</v-icon>
                            </v-avatar>
                            {{$tc('listado_materiales') | capitalize}}
                        </v-toolbar-title>

                        <div class="flex-grow-1"></div>
                        <template>
                            <v-btn icon color="primary" :disabled="materiales.cargando" @click="cargarMateriales()">
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                            <btn-add-material-pers :disabled="materiales.cargando" @actualizado="actualizadoMaterial">
                            </btn-add-material-pers>
                        </template>
                    </v-toolbar>
                    <v-progress-linear indeterminate :active="materiales.cargando"/>
                    <v-list>
                        <div v-if="materiales.cargando">
                            <v-skeleton-loader v-for="i in materiales.porPagina" :key="i"
                                               ref="skeleton"
                                               type="list-item-avatar"
                                               class="mx-auto"
                            />
                        </div>
                        <div v-if="!materiales.cargando">
                            <v-list-item v-for="(material,index) in materiales.listado" :key="index" three-line-line>
                                <v-list-item-avatar>
                                    <v-avatar>
                                        <v-img :src="calcularMaterialImgSrc({'codigo':material.material.tipoSolCons}, material.material)"/>
                                    </v-avatar>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-row no-gutters>
                                        <v-col cols="9">
                                            <v-list-item-title class="primary--text font-weight-bold">
                                                {{material.codigo}}&nbsp;|
                                                {{descripcionTipSolCons(material.material.tipoSolCons)}}&nbsp;|
                                                {{material.material.nombre}}&nbsp;
                                            </v-list-item-title>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-row no-gutters>
                                        <v-col>
                                            <btn-ver-material :material="material"/>
                                        </v-col>
                                        <v-col>
                                            <btn-add-material-pers :material-edit="material"
                                                                   :disabled="materiales.cargando"
                                                                   @actualizado="actualizadoMaterial">
                                            </btn-add-material-pers>
                                        </v-col>
                                        <v-col>
                                            <btn-borrar-material :material="material" @borrado="borradoMaterial">
                                            </btn-borrar-material>
                                        </v-col>
                                    </v-row>
                                </v-list-item-action>
                            </v-list-item>
                        </div>
                    </v-list>

                    <div class="text-center">
                        <v-pagination
                                circle
                                v-model="materiales.pagina"
                                :length="materiales.paginas"
                                :disabled="materiales.cargando"
                        />
                    </div>
                </v-col>
            </v-row>
        </div>

        <v-alert v-if="!proyectos.cargando && proyectos.paginas === 0" type="info" class="ma-12">
            <span class="body-1">{{$t('sin_proyectos')}}&nbsp;</span>
            <v-btn color="primary" class="ml-4" depressed @click="goTo('proyecto-nuevo')">
                {{$t('crear_proyecto')}}
            </v-btn>
        </v-alert>
        <div v-if="proyectos.cargando || proyectos.paginas > 0">
            <v-row no-gutters>
                <v-col cols="12">
                    <v-toolbar color="transparent primary--text" flat>
                        <v-toolbar-title class="font-weight-bold">{{$tc('listado_proyectos',2) | capitalize}}
                        </v-toolbar-title>

                        <div class="flex-grow-1"></div>

                        <template>
                            <v-btn icon color="primary" :disabled="proyectos.cargando" @click="cargarProyectos()">
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" :disabled="proyectos.cargando" @click="goTo('proyecto-nuevo')">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-toolbar>
                    <v-progress-linear indeterminate :active="proyectos.cargando"/>
                    <v-list>
                        <div v-if="proyectos.cargando">
                            <v-skeleton-loader v-for="i in proyectos.porPagina" :key="i"
                                               ref="skeleton"
                                               type="list-item-avatar-two-line"
                                               class="mx-auto"
                            />
                        </div>
                        <div v-if="!proyectos.cargando">
                            <v-list-item v-for="(proyecto,index) in proyectos.listado" :key="index" three-line>
                                <v-list-item-avatar>
                                    <v-avatar>
                                        <v-img v-if="proyecto.tipoSolCons"
                                               :src="calcularSolConsImgSrc(proyecto.tipoSolCons)"/>
                                    </v-avatar>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-row no-gutters>
                                        <v-col cols="9">
                                            <v-list-item-title class="primary--text font-weight-bold">
                                                {{proyecto.nombre}}
                                            </v-list-item-title>

                                            <v-list-item-subtitle v-if="proyecto.solucionesConstructivas.length > 0">
                                                {{proyecto.tipoSolCons.nombre}}
                                                &nbsp;-&nbsp;{{tituloMaterial(proyecto.solucionesConstructivas[0])}}
                                                &nbsp;vs&nbsp;{{tituloMaterial(proyecto.solucionesConstructivas[1])}}
                                                &nbsp;-&nbsp;{{proyecto.created | formatDate}}
                                            </v-list-item-subtitle>

                                            <v-list-item-subtitle class="body-1 font-italic">
                                                {{proyecto.descripcion}}
                                            </v-list-item-subtitle>
                                        </v-col>
                                        <v-col cols="3" class="text-right"
                                               v-if="proyecto.solucionesConstructivas.length > 0">
                                            <v-avatar v-for="sc in proyecto.solucionesConstructivas" :key="sc.id">
                                                <v-img :src="calcularMaterialImgSrc(proyecto.tipoSolCons, sc.materialDermis)"/>
                                            </v-avatar>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn v-if="proyecto.solucionesConstructivas.length > 0" icon
                                           @click="goTo('proyecto-detalles/'+proyecto.id)">
                                        <v-icon color="primary">mdi-chevron-right</v-icon>
                                    </v-btn>
                                    <btn-solicitar-proyecto v-if="proyecto.solucionesConstructivas.length < 1"
                                                            :proyecto-id="proyecto.id"/>
                                </v-list-item-action>
                            </v-list-item>
                        </div>
                    </v-list>

                    <div class="text-center">
                        <v-pagination
                                circle
                                v-model="proyectos.pagina"
                                :length="proyectos.paginas"
                                :disabled="proyectos.cargando"
                        />
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
    import ImagenesServicio from "../../comunes/servicios/ImagenesServicio";
    import BtnBorrarMaterial from "./Componentes/BtnBorrarMaterial";
    import BtnVerMaterial from "./Componentes/BtnVerMaterial";
    import BtnAddMaterialPers from "./Componentes/BtnAddMaterial/BtnAddMaterialPers";
    import DescripcionesServicio from "../../comunes/servicios/DescripcionesServicio";
    import BtnSolicitarProyecto from "./Componentes/BtnSolicitarProyecto";

    export default {
        name: 'ProyectoListadoPagina',
        components: {
            BtnBorrarMaterial,
            BtnVerMaterial,
            BtnAddMaterialPers,
            BtnSolicitarProyecto
        },
        data: () => ({
            snackbar: {
                tipo: "error",
                mostrar: false,
                mensaje: ""
            },
            proyectos: {
                listado: [],
                cargando: false,
                pagina: 1,
                porPagina: 5,
                paginas: 0
            },
            materiales: {
                listado: [],
                cargando: false,
                pagina: 1,
                porPagina: 5,
                paginas: 0
            }
        }),
        mounted() {
            this.cargarProyectos();
            this.cargarMateriales();
        },
        watch: {
            'proyectos.pagina': function () {
                this.cargarProyectos();
            },
            'materiales.pagina': function () {
                this.cargarMateriales();
            }
        },
        methods: {
            calcularMaterialImgSrc(solCons, material) {
                return ImagenesServicio.imgMaterial(solCons.codigo, material.referencia);
            },
            calcularSolConsImgSrc(solCons) {
                return ImagenesServicio.imgTipoSolucionConstructivaS3(solCons.codigo);
            },
            descripcionTipSolCons(tipSolCons) {
                return DescripcionesServicio.descripcionTipoSolCons(tipSolCons);
            },
            tituloMaterial(solCons) {
                return DescripcionesServicio.materialSolCons(solCons);
            },
            goTo(path) {
                VueRouteHelper.goTo(path, this.$router);
            },
            cargarProyectos() {
                if (this.proyectos.cargando) return;

                this.proyectos.cargando = true;
                let params = {
                    pagina: this.proyectos.pagina - 1,
                    porPagina: this.proyectos.porPagina
                };

                HttpHelper.get('proyecto/listado', params)
                    .then((res) => {
                        this.proyectos.listado = res.content;
                        this.proyectos.paginas = res.totalPages;
                    })
                    .finally(() => {
                        this.proyectos.cargando = false;
                    });
            },
            cargarMateriales() {
                if (this.materiales.cargando) return;

                this.materiales.cargando = true;
                let params = {
                    pagina: this.materiales.pagina - 1,
                    porPagina: this.materiales.porPagina
                };

                HttpHelper.get('material-personalizado/listado', params)
                    .then((res) => {
                        this.materiales.listado = res.content;
                        this.materiales.paginas = res.totalPages;
                    })
                    .finally(() => {
                        this.materiales.cargando = false;
                    });
            },
            actualizadoMaterial() {
                this.cargarMateriales();
                this.snackbar.tipo = "success";
                this.snackbar.mensaje = this.$t("material_actualizado");
                this.snackbar.mostrar = true;
            },
            borradoMaterial() {
                this.cargarMateriales();
                this.snackbar.tipo = "success";
                this.snackbar.mensaje = this.$t("material_borrado");
                this.snackbar.mostrar = true;
            }
        }
    };
</script>

<style lang="scss">
    .contenedor-principal {
        padding: 0;
    }

    .v-pagination {
        button {
            box-shadow: none !important;
        }
    }
</style>

<style scoped lang="scss">
    .v-alert.info {
        background-color: #f7d9cd !important;
        color: #40108e !important;
        .v-icon, .v-icon::before {
            color: #40108e !important;
            font-size: 30px !important;
            margin-top: 5px !important;
        }
    }
</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "listado_proyectos": "Proyectos guardados",
    "sin_proyectos": "No tienes ningún proyecto, puedes crear uno pulsando el botón",
    "crear_proyecto": "Crear proyecto",
    "listado_materiales": "Biblioteca de materiales",
    "sin_materiales": "No tienes ningún material creado, para crear un nuevo material pulsando el botón: ",
    "material_actualizado": "Material actualizado correctamente",
    "material_borrado": "Material borrado correctamente"
    }
    }
</i18n>
<!--@formatter:oon-->
